import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import * as Sentry from '@sentry/react'
import App from './App'
import { getSystemVersion } from './utils/version'
import './index.css'

// Configuração do Sentry
Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN || "https://7c45b11347121527ef9fb5eb354ff4a9@o4510391995662336.ingest.de.sentry.io/4510392001953872",
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration({
      // Configura o replay de sessão para depuração
      maskAllText: false,
      blockAllMedia: false,
    }),
  ],
  // Configura a amostragem de performance
  tracesSampleRate: 1.0, // Captura 100% das transações em desenvolvimento
  // Configura a amostragem de replay
  replaysSessionSampleRate: 0.1, // 10% das sessões
  replaysOnErrorSampleRate: 1.0, // 100% das sessões com erro
  // Configura o ambiente
  environment: import.meta.env.MODE,
  // Configura a release — usa a mesma fonte única que o resto do app.
  release: `doBeco-frontend@${getSystemVersion().replace(/^v/, '')}`,
  // Envia dados PII padrão para melhor análise
  sendDefaultPii: true,
})

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>,
)